export const moveInReadySerialNumbers = [
  'CAP042497TNABAC',
  'CWP057854TNABAC',
  'CAP038675TNAB',
  'CWP053009TNAB',
  'SGI026131TNAC',
  'SGI024868TNAC',
  'CAP041834TNABAC',
  'CWP054174TN',
  'SGI025914TNABAC',
  'CWP058585TNAC',
  'RIC255742NCABM ',
  'SAD032796ALAC',
  'SAD033076ALAC',
  'BEL023142TXAC',
  'CLW056018TXAC',
  'CLW056894TXAC',
  'CBH038682TXAC',
  'CLW055313TX',
  'BL2011857TXABAC',
  'CLW055152TX',
  'CBH038002TX',
  'BL2008540TXAB',
  'BL2008028TXAB',
  'SFW031479TXABAC',
  'CLW056651TXAC',
  'ATH004839TX',
  'ATH004925TXAB',
  'CLW056720TXAC',
  'CLW057044TXAC',
  'CLW056028TXAC',
  'CLW056928TXAC',
  'BEL022893TXAC',
  'BEL021532TXAC',
  'BEL022647TXAC',
  'BEL022770TXAC',
  'CLW055066TX',
  'OHC033440NCAC',
  'CWP059420TNABAC',
  'OHC033681NCAC',
  'CBG057359NCABAC',
  'OHC032091NCAB',
  'ROC746736NCABAC',
  'ROC746737NCABAC',
  'ROC746902NCABAC',
  'ROC745361NCAC',
  'BL2009379TXAB',
  'CBH038399TXAC',
  'SFW030685TXABAC',
  'CBH038257TXAC',
  'BEL017890TX',
  'CLW052729TX',
  'CS2030537TNAC',
  'CS2031192TNAC',
  'CS2031194TNAC',
  'CS2030961TNAC',
  'SAD031472ALAB',
  'SAD031790ALAB',
  'CAP041664TNABAC',
  'OHC032814NCAB',
  'CLM114443TN',
  'LEW118520PAABAC',
  'CBH038594TXAC',
  'CBH037908TXAC',
  'SAD031772ALAB',
  'CLR035295TNAB',
  'CBH037790TXAC',
  'SRB045618ALAC',
  'CBH038374TXAC',
  'BEL022215TXABAC',
  'BL2012037TXABAC',
  'CBH037491TX',
  'BEL020168TX',
  'CLH050489TNABAC',
  'ROC745052NCAC',
  'CBG056300NC',
  'LEW118528PAAC',
  'CLW055567TXAC',
  'CBH038895TXAC',
  'SRB046826ALAC',
  'CBH038013TXAC',
  'SA4084962ALABAC',
  'CBH038137TXAC',
  'CBH037526TX',
  'CBH038371TXAC',
  'CLW053531TX',
  'CLW055141TX',
  'BEL020262TX',
  'CLW056931TXAC',
  'SGI026130TNAC',
  'ATH004968TXAB',
  'SAD030525ALAB',
  'CSS025810TXAB',
  'BL2008779TXAB',
  'NO2029465TNAB',
  'CSS026147TXAB',
  'CLW055304TX',
  'CLW053019TX',
  'CLW053374TX',
  'SFW030175TXAB',
  'CSS026745TXAB',
  'BEL016049TX',
  'CLW056877TXAC',
  'CAP040620TNAB',
  'BUC015260AZAC',
  'BL2010376TXAB',
  'CLM112382TN',
  'BEL022290TXAC',
  'SFW030499TXAC',
  'BEL019131TX',
  'WHC031158GAABAC',
  'SA4086398ALABAC',
  'BEL021032TXABAC',
  'BL2011005TXABAC',
  'BL2011004TXABAC',
  'BL2011330TXABAC',
  'CBH037986TXAC',
  'SAC039029CA',
  'CSS026371TXAB',
  'CSS025752TXAB',
  'WHC031289GAABAC',
  'BEL016987TX',
  'BL2012036TXABAC',
  'CBH038380TXAC',
  'NME010486NMAC',
  'LEW119228PAABAC',
];
